import { Page, View, Image, Text, Link } from '@react-pdf/renderer';
import { styles } from './styles';
import {
  Portfolio,
  PublicEventDetailsResponse,
  ResponsePaginationType,
} from '@hubs101/booking-api-skd-client/lib/types';
import { useTranslation } from 'react-i18next';

export interface ContactPageProps {
  event: PublicEventDetailsResponse;
  coLocatedEvents: PublicEventDetailsResponse[] | undefined;
  portfolios: ResponsePaginationType<Portfolio> | undefined;
  header: JSX.Element;
  footer: JSX.Element;
}

const mailTo = [
  {
    email: 'bookings@we-conect.com',
    icon: 'https://media.we-conect.com/images/pdf/agenda/ticket_4x.png',
    subject: 'we-are-happy-to-help-you-item-subject-1',
    body: 'we-are-happy-to-help-you-item-body-1',
  },
  {
    email: 'partnering@we-conect.com',
    icon: 'https://media.we-conect.com/images/pdf/agenda/rocket_4x.png',
    subject: 'we-are-happy-to-help-you-item-subject-2',
    body: 'we-are-happy-to-help-you-item-body-2',
  },
  {
    email: 'speaking@we-conect.com',
    icon: 'https://media.we-conect.com/images/pdf/agenda/microphone_4x.png',
    subject: 'we-are-happy-to-help-you-item-subject-3',
    body: 'we-are-happy-to-help-you-item-body-3',
  },
  {
    email: 'operations@we-conect.com',
    icon: 'https://media.we-conect.com/images/pdf/agenda/globe_4x.png',
    subject: 'we-are-happy-to-help-you-item-subject-4',
    body: 'we-are-happy-to-help-you-item-body-4',
  },
];

const ContactPage = ({
  event,
  coLocatedEvents,
  portfolios,
  header,
  footer,
}: ContactPageProps) => {
  const { t } = useTranslation();

  return (
    <Page size="A4" orientation="portrait" style={styles.page}>
      <View style={styles.backgroundContainer}>
        <Image
          src={
            'https://media.we-conect.com/images/pdf/agenda/pdf_agenda_contact.jpg'
          }
          style={styles.backgroundImage}
        />

        <View>{header}</View>

        <View style={styles.overlayContent}>
          <Text style={styles.subtitle}>{t('feel-free-to-contact-us')}</Text>
          <Text style={styles.title}>{t('do-you-have-any-questions-pdf')}</Text>
          <View
            style={{
              ...styles.lineBar,
            }}
          ></View>
        </View>
      </View>

      <View
        style={{
          ...styles.contentWrapper,
        }}
      >
        <Text style={styles.boldText}>{t('we-are-happy-to-help-you')}</Text>
        <Text style={styles.text}>
          {t('we-are-happy-to-help-you-description')}
        </Text>

        <View style={styles.contactGrid}>
          {[1, 2, 3, 4].map((_, index) => {
            const eventName = event?.name ?? 'Event';
            const mailtoLink = `mailto:${mailTo[index].email}?subject=${encodeURIComponent(
              `${t(mailTo[index].subject, { eventName })}`
            )}&body=${encodeURIComponent(
              `${t(mailTo[index].body, { eventName })}`
            )}`;

            return (
              <View key={index} style={styles.gridItem}>
                <View style={styles.contentBox}>
                  <View style={styles.roundedIconWrapper}>
                    <Image
                      src={mailTo[index].icon}
                      style={styles.roundedIcon}
                    />
                  </View>
                  <Text style={styles.contentText}>
                    {t(`we-are-happy-to-help-you-item-text-${index + 1}`)}
                  </Text>
                </View>

                <View
                  style={{
                    ...styles.fullWidthButton,
                    backgroundColor: event?.design?.themeColor ?? 'black',
                  }}
                >
                  <Link src={mailtoLink} style={styles.buttonText}>
                    {t('make-contact')}
                  </Link>
                </View>
              </View>
            );
          })}
        </View>
      </View>

      {footer}
    </Page>
  );
};

export default ContactPage;
